import styled from "styled-components";
import Colors from "../../../themes/Colors";

export const CierreContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  background-color: transparent;
  padding: 0 0 10px 0;
  display: flex;
  justify-content: center;
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 230px;
  max-width: 260px;
  flex: 0 0 auto;
`;

export const FieldHeader = styled.label`
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  padding: 10px 16px;
  text-align: center;
  background-color: #d6e4f0;
  color: #1a1a1a;
  border-radius: 2px 2px 0 0;
  box-sizing: border-box;
`;

export const FieldInput = styled.input`
  height: 36px;
  padding: 0 10px;
  border: 1px solid ${Colors.border || "#d9d9d9"};
  border-top: none;
  border-radius: 0 0 2px 2px;
  font-size: 14px;
  outline: none;
  background-color: #ffffff;
  box-sizing: border-box;

  &:focus {
    border-color: ${Colors.huMyHealth || "#00a0df"};
  }
`;

export const SearchButton = styled.button`
  height: 48px;
  padding: 0 60px;
  border: none;
  border-radius: 999px;
  background-color: #18498f;
  color: #ffffff;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const DetalleWrapper = styled.div`
  width: 100%;
  padding: 10px 0 30px 0;
  box-sizing: border-box;
`;

export const DetalleTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
  margin: 0 auto 10px auto;
  width: 95%;
  max-width: 1200px;
`;

export const DetalleSubtitle = styled.h4`
  font-size: 15px;
  font-weight: bold;
  margin: 20px auto 10px auto;
  width: 95%;
  max-width: 1200px;
`;

export const TableContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
`;

export const DetalleDescription = styled.p`
  width: 95%;
  max-width: 1200px;
  margin: -5px auto 15px auto;
  font-size: 14px;
  color: #555;
  line-height: 1.4;
`;

export const CoberturasWrapper = styled.div`
  width: 100%;
  max-width: 1700px;
  margin: 0 auto 10px;
  overflow-x: hidden;
`;

export const CoberturasContainer = styled.div`
  width: 100%;
  max-width: 1700px;
  margin: 0 auto;
  margin-bottom: 10px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const CoberturasCard = styled.div`
  width: 100%;
`;

export const ModalBody = styled.div`
  padding: 8px 10px;
`;

export const ModalTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h3`
  margin: 0;
  font-weight: bold;
  color: #2c3e50;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 38px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 0 12px;
  outline: none;

  &:focus {
    border-color: #93c5fd;
    box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.35);
  }
`;

export const ModalTableScroll = styled.div`
  max-height: 420px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #eef2f7;
  border-radius: 10px;
`;

export const SelectBtn = styled.button`
  border: none;
  background: #0b66c3;
  color: white;
  font-weight: 700;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    filter: brightness(0.95);
  }
`;

export const ErrorBox = styled.div`
  padding: 10px;
  border: 1px solid #f3c6c6;
  border-radius: 8px;
  background: #fff5f5;
  color: #8a1f1f;
`;

export const DetalleContainer = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;
